import { useAuth } from '../context/AuthContext';
import { getTaxTerms } from '../utils/taxTerms';

/**
 * React hook returning the active company's tax-related labels.
 *
 * Usage:
 *   const { registrationLabel, taxNumberLabel, taxLabel } = useTaxTerms();
 *   <label>{registrationLabel}</label>  // "NTN" in PK, "CR" in VAT mode
 */
const useTaxTerms = () => {
  const { activeCompany } = useAuth();
  return getTaxTerms(activeCompany);
};

export default useTaxTerms;
